import { useState } from 'react';
import api from "../../../../services/api";

/**
 * 아카이브 > 회고록 > 메인
 * 제목 별 검색 api 호출 hook
 */
const useApiByTitle = () => {
    const [data, setData] = useState([]);

    const fetchBiographyByTitle = async (searchTerm) => {

        console.log('검색어 ', searchTerm);
        try {
            const response = await api.post("/get_books_by_category_and_title", {
                book_category: "biography",
                words: searchTerm,
            });
            const formattedData = response.data.data.map(item => ({
                book_id: item.book_id,
                authors: item.authors,
                book_title: item.book_title,
                numeration: item.numeration,
                publish_year: item.publish_year,
                publisher: item.publisher,
                library: item.library,
                url: item.url,
                book_category: item.book_category,
                authors_ko: item.authors_ko,
                book_title_ko: item.book_title_ko,
                publish_date: item.publish_date,
                publisher_ko: item.publisher_ko,
                note: item.note,
                n_tocs: item.n_tocs,
            }));
            setData(formattedData);
            return formattedData; // 호출한 함수에도 데이터 반환
        } catch (error) {
            console.error("Search error:", error);
            return [];
        }
    };

    return { data, fetchBiographyByTitle };
};

export default useApiByTitle;
